import React from 'react';
import { DNAButton, DNAText } from '@alucio/lux-ui';
import DNAPopover from 'src/components/DNA/Popover/DNAPopover';
import { useSidebar } from '../SidebarProvider';
import { styles } from '..';

const ChevronButton: React.FC = () => {
  const { selectedSideBarOption, toggleSidebar } = useSidebar();

  return (
    <DNAPopover placement="left" disablePopover={['tabletPWA']}>
      <DNAPopover.Anchor>
        <DNAButton
          appearance="ghost"
          status="tertiary"
          size="lg"
          iconLeft={!selectedSideBarOption ? 'caret-left' : 'caret-right'}
          onPress={toggleSidebar}
        />
      </DNAPopover.Anchor>
      <DNAPopover.Content>
        <DNAText style={styles.tooltipText} numberOfLines={1}>
          {selectedSideBarOption ? 'Collapse' : 'Expand'}
        </DNAText>
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export default ChevronButton;
